import captureException from './captureException';
export const getLocalStorageItem = key => {
  try {
    const value = localStorage.getItem(key);
    return value || '';
  } catch (err) {
    captureException(err);
    return '';
  }
};
export const setLocalStorageItem = (key, value) => {
  try {
    localStorage.setItem(key, value);
  } catch (err) {
    captureException(err);
  }
};